import { render, staticRenderFns } from "./SectionHeading.vue?vue&type=template&id=20657d11&scoped=true"
import script from "./SectionHeading.vue?vue&type=script&lang=js"
export * from "./SectionHeading.vue?vue&type=script&lang=js"
import style0 from "./SectionHeading.vue?vue&type=style&index=0&id=20657d11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20657d11",
  null
  
)

export default component.exports